module.exports = __webpack_public_path__ + "assets/img/Slice2.166f69ba.png";